import { useContext, useContextSelector } from 'use-context-selector';
import SettingsContext from '../contexts/SettingsContext';
import type { SettingsContextValue } from '../contexts/SettingsContext';

// Overload for when no selector is provided. Returns the entire context value.
function useSettings(): SettingsContextValue;
// Overload for when a selector is provided. Returns only the selected slice of state.
function useSettings<T>(selector: (state: SettingsContextValue) => T): T;
// Implementation of the overloaded function.
function useSettings<T>(selector?: (state: SettingsContextValue) => T): T | SettingsContextValue {
  // If a selector function is passed, use useContextSelector for performance.
  if (selector) {
    return useContextSelector(SettingsContext, selector);
  }
  // Otherwise, return the entire context value for backward compatibility.
  return useContext(SettingsContext);
}

export default useSettings;
